// Final centered CTA. Auth-aware.

import { useCurrentUser } from "@/lib/auth";
import { appHref } from "@/components/home/links";

export default function HomeCTA() {
  const { data: user } = useCurrentUser();
  const target = user ? "/post-login" : "/login";

  return (
    <section
      id="start"
      className="mx-auto max-w-[1320px] border-t border-border px-7 pt-20 pb-12 text-center"
    >
      <h2
        className="serif mx-auto mb-[18px] max-w-[760px] text-[64px] font-normal leading-none tracking-[-0.02em] text-ink"
        style={{ textWrap: "pretty" }}
      >
        Three nodes from now,
        <br />
        you&rsquo;ll know if it clicks.
      </h2>
      <p
        className="mx-auto mb-7 max-w-[560px] text-[16px] leading-[1.5] text-ink-2"
        style={{ textWrap: "pretty" }}
      >
        Hello Harness is two agents and a tool. Sign in, watch a simulated run,
        and you&rsquo;ll have the metaphor in under a minute. Then sketch your
        own &mdash; and export it to whatever you already use.
      </p>
      <a
        href={appHref(target)}
        className="inline-flex h-11 items-center gap-2 rounded-[10px] px-[22px] text-[14px] font-medium text-white"
        style={{ background: "var(--accent)" }}
      >
        Open Studio
        <svg
          width="13"
          height="13"
          viewBox="0 0 16 16"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          aria-hidden
        >
          <path d="M3 8h10M9 4l4 4-4 4" />
        </svg>
      </a>
    </section>
  );
}
